import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import SaveForLaterActions from 'actions/SaveForLaterActions';
import { userSelector } from 'selectors/user/userSelector';
import {
    saveForLaterItemsSelector,
    saveForLaterListIdSelector,
    movingSkuIdsSelector,
    confirmationSelector
} from 'selectors/saveForLater/saveForLaterSelectors';

const { wrapHOC } = FrameworkUtils;

const fields = createSelector(
    saveForLaterItemsSelector,
    saveForLaterListIdSelector,
    movingSkuIdsSelector,
    confirmationSelector,
    userSelector,
    (items, listId, movingSkuIds, confirmation, user) => ({
        items,
        listId,
        movingSkuIds,
        confirmation,
        userId: user?.userId || user?.profileId
    })
);

const functions = {
    handleClose: SaveForLaterActions.closeSavedForLaterModal,
    removeSavedForLater: SaveForLaterActions.removeItemFromSaveForLater,
    showChangeMethodModal: SaveForLaterActions.showChangeMethodModalForSaveForLater,
    moveItemToBasket: SaveForLaterActions.moveItemToBasketFromSaveForLater,
    setMovingSku: SaveForLaterActions.setMovingSku,
    removeMovingSku: SaveForLaterActions.removeMovingSku,
    clearConfirmation: SaveForLaterActions.clearConfirmation,
    undoMoveToBasket: SaveForLaterActions.undoMoveToBasket
};

const withSavedForLaterModalProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withSavedForLaterModalProps
};
